<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{ "files.form.uploadBizzDev.fullLabel" | translate }}
                <app-tooltip
                    [text]="'files.form.uploadBizzDev.summary' | translate"
                ></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="upload-bizzdev-view">
            <aside class="side-block">
                <form>
                    <mat-form-field>
                        <mat-label>{{
                            "dashboardBizzDev.testComparison.providerForm.fullLabel"
                                | translate
                        }}</mat-label>
                        <mat-select name="provType" [(ngModel)]="provider"
                                [disabled]="isDisabled" (selectionChange)="onProviderChange()">
                            <mat-option *ngFor="let enum of providerType" [value]="enum">{{ enum }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field *ngIf="provider === 'sicbxl'">
                        <mat-label>Choix du dossier</mat-label>
                        <mat-select name="folders" [(ngModel)]="folder">
                            <mat-option *ngFor="let fold of sicbxlFolders" [value]="fold">{{ fold }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </form>
            </aside>

            <ng-container *ngIf="(provider === 'sic' || provider === 'sicbxl') && folder">
                <section>
                    <app-upload-multi
                        (afterFilesUpload)="moveFilesToDestPath($event)"
                    ></app-upload-multi>
                </section>
            </ng-container>

            <ng-container *ngIf="provider == 'bbc2020'">
                <section>
                    <mat-checkbox [checked]="isEnabledImport" [disabled]="!canImport" (change)="isEnabledImportChanged($event)">
                        {{ "files.form.enableJobImport.summary" | translate }}
                    </mat-checkbox>
                </section>
            </ng-container>
        </div>
        <app-data-to-be-updated></app-data-to-be-updated>
    </mat-card-content>
</mat-card>
